import React, {useState, useEffect} from 'react';
import Card from './Card';
import Data from '../data/home';


function About(props) {
    const [aboutData, setAboutData] = useState(Data.about);
        return ( 
            <>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 mb-4 mt-2 text-center">
                            <h2 style={{ fontWeight: '800'}}>{ aboutData.title }</h2>
                        </div>
                    </div>
                </div>
                <div className="container about-container" style={{ marginTop: '30px' }}>
                    <div className="row">
                        <div className="col-sm-6 col-lg-8">
                            { aboutData.content.map((paragraph,index) => (
                                    <>
                                        <h3 style={{fontWeight: '600'}}>{paragraph.title}</h3> 
                                        <div dangerouslySetInnerHTML={{__html: paragraph.body}} className="about-body"></div>
                                    </>
                                ) 
                            )}
                        </div>
                        <div className="col-sm-6 col-lg-4">
                            <img src={ "/images/" + aboutData.image } alt={aboutData.image_alt} style={{ width: '100%', height: 'auto' }} />
                        </div>
                    </div>
                </div>
            </>
        );
    }
export default About;